<template>
  <div v-if="show">
    <div class="modal modal-large" :class="[{ show: show }]">
      <!-- Header-->
      <ModalHeader :title="title" @closeModal="closeModal"></ModalHeader>

      <!-- Modal Body-->
      <div class="modal-body">
        <div class="scroll-body">
          <SettingsForm
            v-for="field in fields"
            :key="field._id"
            :fields="field.fields"
            :content="field.content"
            additionalClass="two-column-form"
          ></SettingsForm>
          <button class="btn btn-small btn-primary" @click="addUser">
            Add User
          </button>
        </div>
      </div>
    </div>

    <div class="bg-overlay light show" @click="closeModal"></div>
  </div>
</template>

<script>
// Components
import ModalHeader from "@/components/modals/ModalHeader";
import SettingsForm from "@/components/form/SettingsForm";

export default {
  name: "AddUserModal",
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },

  computed: {},
  data() {
    return {
      title: "Add User",
      waitingForResponse: false,
      fields: {
        user: {
          content: {},
          fields: {
            name: {
              type: "text",
              placeholder: "Add the full name",
              required: true,
              hasError: false,
              title: "Full name*",
              value: "",
            },
            email: {
              type: "email",
              placeholder: "Add the e-mail address",
              required: true,
              hasError: false,
              title: "E-Mail address*",
              value: "",
            },
          },
        },
      },
      showOptions: {
        lineLoader: false,
        showShadow: false,
        preLoader: true,
      },
      status: {
        show: false,
        status: "success",
        title: "Users added",
      },
    };
  },
  components: {
    ModalHeader,
    SettingsForm,
  },
  created() {},

  methods: {
    // Add the user to the team
    async addUser() {
      const data = this.fields.user.fields;
      var isFormValid = this.validateForm(data);
      if (isFormValid) {
        this.$emit("addUser", this.parseData(data));
      }
    },

    // Hide modal
    closeModal() {
      this.$emit("closeModal");
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/shared/dashboard.scss";

.modal {
  &.show-success {
    width: auto;
  }

  .modal-body ::v-deep {
    .settings-form .field-item .field-wrapper {
      min-width: 50%;
    }

    .settings-form {
      margin: 0;
      padding-bottom: 0;
      border-bottom: none;

      .field-item input[disabled] {
        color: $greyColor;

        &:hover {
          border: 1px solid $inputBorderColor !important;
        }
      }
    }
  }
}

.btn-primary {
  float: right;
}
</style>
